import $ from 'jquery';
import 'slick-carousel';

const sliderLogoBrand = () => {
	const el = {
		target: '.mi-carousel__logo .gallery',
	};

	const init = () => {
		$(function () {
			if (!$(el.target).length) return;

			exec();
		});
	};

	const exec = () => {
		$(el.target).slick({
			dots: false,
			arrows: false,
			infinite: true,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 6400,
			cssEase: 'linear',
			pauseOnHover: true,
			pauseOnFocus: true,
		});
	};
	init();
};

try {
	sliderLogoBrand();
} catch (error) {
	console.error(error);
}
